import React from "react";

/**
 * Geographic anchor at the visual center of HTML marker content (pigeon-maps overlay).
 * Map injects `left` / `top` from lat/lng (pixel position of the anchor point).
 *
 * Uses `left` / `top` + `translate(-50%, -50%)` so the anchor stays fixed when overlay
 * content size changes (e.g. zoom-scaled HTML). Chained `translate(px) translate(%)`
 * on a zero-sized absolute box breaks %-centering; pigeon `Marker` uses bottom-center
 * math with changing width/height which shifts the icon when zoom changes.
 */
export function KioskCenteredHtmlOverlay({ anchor: _anchor, left, top, html, onClick }) {
  if (left == null || top == null) {
    return null;
  }
  return (
    <div
      style={{
        position: "absolute",
        left: `${left}px`,
        top: `${top}px`,
        transform: "translate(-50%, -50%)",
        pointerEvents: "auto",
      }}
      className="pigeon-click-block"
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
